import { FaHeart } from "react-icons/fa";
import { FaPencilAlt } from "react-icons/fa";
import { FaLightbulb } from "react-icons/fa";
import { FaTools } from "react-icons/fa";
import { FaClipboardList } from "react-icons/fa";
import { IoChatboxEllipses } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../context/SessionContext";
import { showNotification } from "../common/Notification";

const PhaseSelector = () => {
    const phases = [
        { id: 1, title: "Empathize", icon: <FaHeart />},
        { id: 2, title: "Define", icon: <FaPencilAlt />},
        { id: 3, title: "Ideate", icon: <FaLightbulb />},
        { id: 4, title: "Prototype", icon: <FaTools />},
        { id: 5, title: "Test", icon: <FaClipboardList />},
        { id: 6, title: "Communicate", icon: <IoChatboxEllipses />},
    ];
    const navigate = useNavigate();
    const { sessionId } = useSession();

    const handlePhaseClick = (phaseTitle) => {
        navigate(`/session/${sessionId}/${phaseTitle.toLowerCase()}`);
    };

    return (
        <div className="w-full grid grid-cols-6 gap-4">
            {phases.map((phase) => (
                <div
                    key={phase.id}
                    onClick={() => handlePhaseClick(phase.title)}
                    className="bg-white/30 backdrop-blur-md border border-white/40 flex flex-col items-center justify-center w-full px-6 py-8 rounded-2xl cursor-pointer transition-all duration-200 hover:bg-white/40 hover:-translate-y-1 shadow-lg"
                >
                    <div className="text-2xl text-white">{phase.icon}</div>
                    <p className="mt-4 font-semibold text-xs text-white">{phase.title}</p>
                </div>
            ))}
        </div>
    );
}

export default PhaseSelector;